__turbopack_context__.v({
  "box": "Box-module__0dmVeW__box",
});
